var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('asd20-app-header',{attrs:{"title":"Our Schools","icon":"school","version":`${_vm.version}`}}),_c('keep-alive',{attrs:{"include":"SchoolsPage"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }